"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  AddBold: ['add-bold', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M8.5,22A1.5,1.5,0,0,0,10,23.5h4A1.5,1.5,0,0,0,15.5,22V15.75a.25.25,0,0,1,.25-.25H22A1.5,1.5,0,0,0,23.5,14V10A1.5,1.5,0,0,0,22,8.5H15.75a.25.25,0,0,1-.25-.25V2A1.5,1.5,0,0,0,14,.5H10A1.5,1.5,0,0,0,8.5,2V8.25a.25.25,0,0,1-.25.25H2A1.5,1.5,0,0,0,.5,10v4A1.5,1.5,0,0,0,2,15.5H8.25a.25.25,0,0,1,.25.25Z']],
  AddTabAlternate: ['add-tab-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M18.408,6a3.825,3.825,0,0,0-2.414-.972H2.211a2,2,0,0,0-2,2v9.936a2,2,0,0,0,2,2H15.994A3.839,3.839,0,0,0,18.408,18l4.775-4.585a1.956,1.956,0,0,0,0-2.828Zm-1.385,10.55a1.72,1.72,0,0,1-1.029.414H2.711a.5.5,0,0,1-.5-.5V7.532a.5.5,0,0,1,.5-.5H15.994a1.93,1.93,0,0,1,1.029.414l4.394,4.163a.5.5,0,0,1,0,.724Z', 'M10.711,10.718h-1a.25.25,0,0,1-.25-.25v-1a1.25,1.25,0,0,0-2.5,0v1a.25.25,0,0,1-.25.25h-1a1.25,1.25,0,0,0,0,2.5h1a.249.249,0,0,1,.25.25v1a1.25,1.25,0,0,0,2.5,0v-1a.249.249,0,0,1,.25-.25h1a1.25,1.25,0,1,0,0-2.5Z']],
  AddCircle1Alternate: ['add-circle-1-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M6.223,18.115a.948.948,0,0,0-.346-.292,6.489,6.489,0,0,1,0-11.647.946.946,0,0,0,.346-.291l.021-.03A.992.992,0,0,0,5.015,4.371a8.49,8.49,0,0,0,0,15.258.993.993,0,0,0,1.229-1.485Z', 'M14.75,3a9,9,0,1,0,9,9A9.01,9.01,0,0,0,14.75,3Zm0,16a7,7,0,1,1,7-7A7.008,7.008,0,0,1,14.75,19Z', 'M18.515,10.75H16.25A.25.25,0,0,1,16,10.5V8.235a1.25,1.25,0,0,0-2.5,0V10.5a.25.25,0,0,1-.25.25H10.985a1.25,1.25,0,0,0,0,2.5H13.25a.25.25,0,0,1,.25.25v2.264a1.25,1.25,0,0,0,2.5,0V13.5a.25.25,0,0,1,.25-.25h2.265a1.25,1.25,0,0,0,0-2.5Z']],
  BrokenTabRemoveAlternate: ['broken-tab-remove-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M22,17.5a2,2,0,0,0,2-2v-7a2,2,0,0,0-2-2H2a2,2,0,0,0-2,2v7a2,2,0,0,0,2,2Zm-19.5-2A.5.5,0,0,1,2,15V9a.5.5,0,0,1,.5-.5H13.7a.5.5,0,0,1,.456.705l-1,2.236a1.514,1.514,0,0,0,.015,1.154l.99,2.2a.5.5,0,0,1-.456.705ZM21.03,12.969a.75.75,0,1,1-1.061,1.061l-.793-.793a.249.249,0,0,0-.353,0l-.793.793a.75.75,0,0,1-1.061-1.061l.793-.792a.25.25,0,0,0,0-.354l-.793-.793A.75.75,0,0,1,18.03,9.969l.793.793a.249.249,0,0,0,.353,0l.793-.793A.75.75,0,0,1,21.03,11.03l-.793.793a.25.25,0,0,0,0,.354Z']],
  AddCircleBoldAlternate: ['add-circle-bold-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M12,0A12,12,0,1,0,24,12,12.013,12.013,0,0,0,12,0Zm0,21a9,9,0,1,1,9-9A9.01,9.01,0,0,1,12,21Z', 'M17.25,10.568H13.682a.25.25,0,0,1-.25-.25V6.75a.958.958,0,0,0-.955-.955h-.954a.958.958,0,0,0-.955.955v3.568a.25.25,0,0,1-.25.25H6.75a.957.957,0,0,0-.955.954v.955a.958.958,0,0,0,.955.955h3.568a.25.25,0,0,1,.25.25V17.25a.957.957,0,0,0,.955.954h.954a.957.957,0,0,0,.955-.954V13.682a.25.25,0,0,1,.25-.25H17.25a.958.958,0,0,0,.955-.955v-.955A.957.957,0,0,0,17.25,10.568Z']],
  AddSquareAlternate: ['add-square-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M21.545.25H2.455a2.206,2.206,0,0,0-2.2,2.2V21.546a2.207,2.207,0,0,0,2.205,2.2h19.09a2.207,2.207,0,0,0,2.2-2.2V2.454A2.206,2.206,0,0,0,21.545.25Zm-.3,21H2.75V2.75h18.5Z', 'M6.273,13.25H10.5a.25.25,0,0,1,.25.25v4.227a1.25,1.25,0,0,0,2.5,0V13.5a.25.25,0,0,1,.25-.25h4.227a1.25,1.25,0,0,0,0-2.5H13.5a.25.25,0,0,1-.25-.25V6.272a1.25,1.25,0,1,0-2.5,0V10.5a.25.25,0,0,1-.25.25H6.273a1.25,1.25,0,0,0,0,2.5Z']],
  RemoveSquare1Alternate: ['remove-square-1-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M21.545.25H2.455a2.206,2.206,0,0,0-2.2,2.2V21.546a2.207,2.207,0,0,0,2.205,2.2h19.09a2.207,2.207,0,0,0,2.2-2.2V2.454A2.206,2.206,0,0,0,21.545.25Zm-.3,21H2.75V2.75h18.5Z', 'M7.066,16.934a1.247,1.247,0,0,0,1.767,0l2.99-2.989a.25.25,0,0,1,.353,0l2.99,2.989a1.249,1.249,0,1,0,1.767-1.767l-2.989-2.99a.25.25,0,0,1,0-.354l2.989-2.989a1.25,1.25,0,1,0-1.767-1.768l-2.99,2.99a.25.25,0,0,1-.353,0l-2.99-2.99A1.25,1.25,0,0,0,7.066,8.834l2.989,2.989a.25.25,0,0,1,0,.354l-2.989,2.99A1.249,1.249,0,0,0,7.066,16.934Z']],
  RemoveTabAlternate: ['remove-tab-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M18.121,5.5a3.749,3.749,0,0,0-2.414-1H2.207a2,2,0,0,0-2,2v11a2,2,0,0,0,2,2h13.5a3.749,3.749,0,0,0,2.414-1l5.086-5.086a2,2,0,0,0,0-2.828ZM16.707,17.086a1.635,1.635,0,0,1-1,.414H2.457a.25.25,0,0,1-.25-.25V6.75a.25.25,0,0,1,.25-.25h13.25a1.63,1.63,0,0,1,1,.414L21.793,12Z', 'M11.591,9.116a1.251,1.251,0,0,0-1.768,0l-.939.939a.25.25,0,0,1-.354,0l-.939-.939a1.25,1.25,0,0,0-1.768,1.768l.94.939a.252.252,0,0,1,0,.354l-.94.939a1.25,1.25,0,0,0,1.768,1.768l.939-.94a.25.25,0,0,1,.354,0l.939.94a1.25,1.25,0,1,0,1.768-1.768l-.94-.939a.252.252,0,0,1,0-.354l.94-.939A1.251,1.251,0,0,0,11.591,9.116Z']],
  AddCircle: ['add-circle', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M12,23.5A11.5,11.5,0,1,0,.5,12,11.513,11.513,0,0,0,12,23.5ZM6,11h4.75a.25.25,0,0,0,.25-.25V6a1,1,0,0,1,2,0v4.75a.25.25,0,0,0,.25.25H18a1,1,0,0,1,0,2H13.25a.25.25,0,0,0-.25.25V18a1,1,0,0,1-2,0V13.25a.25.25,0,0,0-.25-.25H6a1,1,0,0,1,0-2Z']],
  SubtractCircleAlternate: ['subtract-circle-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M12,.25A11.75,11.75,0,1,0,23.75,12,11.763,11.763,0,0,0,12,.25Zm0,21A9.25,9.25,0,1,1,21.25,12,9.26,9.26,0,0,1,12,21.25Z', 'M6.273,10.75a1.25,1.25,0,0,0,0,2.5H17.727a1.25,1.25,0,0,0,0-2.5Z']],
  SubtractCircleBoldAlternate: ['subtract-circle-bold-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M12,0A12,12,0,1,0,24,12,12.013,12.013,0,0,0,12,0Zm0,21a9,9,0,1,1,9-9A9.01,9.01,0,0,1,12,21Z', 'M5.795 10.568 L18.204 10.568 L18.204 13.432 L5.795 13.432 Z']],
  SubtractSquareAlternate: ['subtract-square-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M21.545.25H2.455a2.206,2.206,0,0,0-2.2,2.2V21.546a2.207,2.207,0,0,0,2.205,2.2h19.09a2.207,2.207,0,0,0,2.2-2.2V2.454A2.206,2.206,0,0,0,21.545.25Zm-.3,21H2.75V2.75h18.5Z', 'M6.273,13.25H17.727a1.25,1.25,0,0,0,0-2.5H6.273a1.25,1.25,0,0,0,0,2.5Z']],
  SubtractTabAlternate: ['subtract-tab-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M18.408,6a3.825,3.825,0,0,0-2.414-.972H2.211a2,2,0,0,0-2,2v9.936a2,2,0,0,0,2,2H15.994A3.839,3.839,0,0,0,18.408,18l4.775-4.585a1.956,1.956,0,0,0,0-2.828Zm-1.385,10.55a1.72,1.72,0,0,1-1.029.414H2.461a.25.25,0,0,1-.25-.25V7.282a.25.25,0,0,1,.25-.25H15.994a1.93,1.93,0,0,1,1.029.414l4.584,4.343a.251.251,0,0,1,0,.362Z', 'M10.711,10.718h-5a1.25,1.25,0,0,0,0,2.5h5a1.25,1.25,0,1,0,0-2.5Z']],
  SubtractBold: ['subtract-bold', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M0.500 8.500 L23.500 8.500 L23.500 15.500 L0.500 15.500 Z']],
  SubtractCircle: ['subtract-circle', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M12,23.5A11.5,11.5,0,1,0,.5,12,11.513,11.513,0,0,0,12,23.5ZM6,11H18a1,1,0,0,1,0,2H6a1,1,0,0,1,0-2Z']],
  RemoveTab: ['remove-tab', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M15.707,19a3.3,3.3,0,0,0,2.061-.853l5.086-5.086a1.5,1.5,0,0,0,0-2.121L17.768,5.854A3.3,3.3,0,0,0,15.707,5H2.207a1.5,1.5,0,0,0-1.5,1.5v11a1.5,1.5,0,0,0,1.5,1.5ZM5.525,10.232A1,1,0,1,1,6.939,8.818l1.592,1.591a.249.249,0,0,0,.353,0l1.591-1.591a1,1,0,1,1,1.415,1.414L10.3,11.823a.251.251,0,0,0,0,.354l1.592,1.591a1,1,0,0,1-1.415,1.414L8.884,13.591a.249.249,0,0,0-.353,0L6.939,15.182a1,1,0,1,1-1.414-1.414l1.591-1.591a.249.249,0,0,0,0-.354Z']],
  SubtractTab: ['subtract-tab', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M.712,16.968a1.5,1.5,0,0,0,1.5,1.5H16a3.382,3.382,0,0,0,2.067-.832l4.775-4.584a1.455,1.455,0,0,0,0-2.107L18.062,6.364A3.385,3.385,0,0,0,16,5.532H2.212a1.5,1.5,0,0,0-1.5,1.5Zm3-5a1,1,0,0,1,1-1h7a1,1,0,0,1,0,2h-7A1,1,0,0,1,3.712,11.968Z']],
  Subtract: ['subtract', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M1.5,13.5h21a1.5,1.5,0,0,0,0-3H1.5a1.5,1.5,0,0,0,0,3Z']],
  Add: ['add', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M0,12a1.5,1.5,0,0,0,1.5,1.5h8.75a.25.25,0,0,1,.25.25V22.5a1.5,1.5,0,0,0,3,0V13.75a.25.25,0,0,1,.25-.25H22.5a1.5,1.5,0,0,0,0-3H13.75a.25.25,0,0,1-.25-.25V1.5a1.5,1.5,0,0,0-3,0v8.75a.25.25,0,0,1-.25.25H1.5A1.5,1.5,0,0,0,0,12Z']],
  RemoveCircleBoldAlternate: ['remove-circle-bold-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M12,0A12,12,0,1,0,24,12,12.013,12.013,0,0,0,12,0Zm0,21a9,9,0,1,1,9-9A9.01,9.01,0,0,1,12,21Z', 'M16.95,7.757l-.707-.707a1,1,0,0,0-1.415,0L12.177,9.7a.252.252,0,0,1-.354,0L9.172,7.05a1,1,0,0,0-1.415,0l-.707.707a1,1,0,0,0,0,1.414L9.7,11.823a.25.25,0,0,1,0,.354L7.05,14.828a1,1,0,0,0,0,1.414l.707.708a1.006,1.006,0,0,0,1.415,0L11.823,14.3a.25.25,0,0,1,.354,0l2.651,2.652a1.006,1.006,0,0,0,1.415,0l.707-.708a1,1,0,0,0,0-1.414L14.3,12.177a.25.25,0,0,1,0-.354L16.95,9.171A1,1,0,0,0,16.95,7.757Z']],
  AddBoldAlternate: ['add-bold-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M21.545,7.886H16.363a.249.249,0,0,1-.25-.25V2.454a2.206,2.206,0,0,0-2.2-2.2H10.09a2.206,2.206,0,0,0-2.2,2.2V7.636a.249.249,0,0,1-.25.25H2.454a2.207,2.207,0,0,0-2.2,2.2v3.818a2.206,2.206,0,0,0,2.205,2.2H7.636a.25.25,0,0,1,.25.25v5.183a2.206,2.206,0,0,0,2.2,2.2h3.818a2.207,2.207,0,0,0,2.205-2.2V16.363a.25.25,0,0,1,.25-.25h5.182a2.206,2.206,0,0,0,2.2-2.2V10.091A2.206,2.206,0,0,0,21.545,7.886Zm-.3,5.477a.25.25,0,0,1-.25.25H14.863a1.25,1.25,0,0,0-1.25,1.25V21a.25.25,0,0,1-.25.25H10.636a.249.249,0,0,1-.25-.25V14.863a1.25,1.25,0,0,0-1.25-1.25H3a.25.25,0,0,1-.25-.25V10.636a.25.25,0,0,1,.25-.25H9.136a1.25,1.25,0,0,0,1.25-1.25V3a.249.249,0,0,1,.25-.25h2.727a.25.25,0,0,1,.25.25V9.136a1.25,1.25,0,0,0,1.25,1.25H21a.25.25,0,0,1,.25.25Z']],
  RemoveCircle1: ['remove-circle_1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M12,23.5A11.5,11.5,0,1,0,.5,12,11.513,11.513,0,0,0,12,23.5ZM7.05,8.465A1,1,0,1,1,8.464,7.051l3.359,3.359a.25.25,0,0,0,.353,0l3.359-3.359a1,1,0,1,1,1.414,1.414L13.59,11.824a.25.25,0,0,0,0,.353l3.359,3.359a1,1,0,1,1-1.414,1.414l-3.359-3.359a.25.25,0,0,0-.353,0L8.464,16.95A1,1,0,0,1,7.05,15.536l3.359-3.359a.25.25,0,0,0,0-.353Z']],
  RemoveSquare1: ['remove-square_1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M.5,22A1.5,1.5,0,0,0,2,23.5H22A1.5,1.5,0,0,0,23.5,22V2A1.5,1.5,0,0,0,22,.5H2A1.5,1.5,0,0,0,.5,2ZM7.05,8.465A1,1,0,1,1,8.464,7.051l3.359,3.359a.25.25,0,0,0,.353,0l3.359-3.359a1,1,0,1,1,1.414,1.414L13.59,11.824a.25.25,0,0,0,0,.353l3.359,3.359a1,1,0,1,1-1.414,1.414l-3.359-3.359a.25.25,0,0,0-.353,0L8.464,16.95A1,1,0,0,1,7.05,15.536l3.359-3.359a.25.25,0,0,0,0-.353Z']],
  RemoveCircleBold: ['remove-circle-bold', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M12,23.5A11.5,11.5,0,1,0,.5,12,11.513,11.513,0,0,0,12,23.5ZM7.05,9.172a1,1,0,0,1,0-1.415l.707-.707a1,1,0,0,1,1.415,0L11.823,9.7a.25.25,0,0,0,.354,0L14.828,7.05a1,1,0,0,1,1.415,0l.707.707a1,1,0,0,1,0,1.415L14.3,11.823a.25.25,0,0,0,0,.354l2.652,2.651a1,1,0,0,1,0,1.415l-.707.707a1,1,0,0,1-1.415,0L12.177,14.3a.252.252,0,0,0-.354,0L9.172,16.95a1,1,0,0,1-1.415,0l-.707-.707a1,1,0,0,1,0-1.415L9.7,12.177a.25.25,0,0,0,0-.354Z']],
  BrokenTabRemove: ['broken-tab-remove', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M13.931,8.368A1,1,0,0,0,13,7H1.5A1.5,1.5,0,0,0,0,8.5v7A1.5,1.5,0,0,0,1.5,17H13a1,1,0,0,0,.928-1.374l-1.564-3.4a.5.5,0,0,1,0-.417Z', 'M24,8.5A1.5,1.5,0,0,0,22.5,7H16.839a.988.988,0,0,0-.921.609L14.11,11.628a1.008,1.008,0,0,0,.008.763l1.792,3.982a1,1,0,0,0,.928.627H22.5A1.5,1.5,0,0,0,24,15.5Zm-2.47,4.47a.75.75,0,1,1-1.06,1.06l-.793-.793a.252.252,0,0,0-.354,0l-.793.793a.75.75,0,0,1-1.06-1.06l.793-.793a.252.252,0,0,0,0-.354l-.793-.793a.75.75,0,0,1,1.06-1.06l.793.793a.252.252,0,0,0,.354,0l.793-.793a.75.75,0,0,1,1.06,1.06l-.793.793a.252.252,0,0,0,0,.354Z']],
  RemoveBold: ['remove-bold', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M22.664,5.578a1.5,1.5,0,0,0,0-2.121L20.543,1.336a1.5,1.5,0,0,0-2.122,0L12.177,7.581a.251.251,0,0,1-.354,0L5.579,1.336a1.5,1.5,0,0,0-2.122,0L1.336,3.457a1.5,1.5,0,0,0,0,2.121l6.245,6.245a.252.252,0,0,1,0,.354L1.336,18.422a1.5,1.5,0,0,0,0,2.121l2.121,2.121a1.5,1.5,0,0,0,2.122,0l6.244-6.245a.251.251,0,0,1,.354,0l6.244,6.245a1.5,1.5,0,0,0,2.122,0l2.121-2.121a1.5,1.5,0,0,0,0-2.121l-6.245-6.245a.252.252,0,0,1,0-.354Z']],
  AddCircleAlternate: ['add-circle-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M12,23.75A11.75,11.75,0,1,0,.25,12,11.764,11.764,0,0,0,12,23.75Zm0-21A9.25,9.25,0,1,1,2.75,12,9.26,9.26,0,0,1,12,2.75Z', 'M6.273,13.25H10.5a.25.25,0,0,1,.25.25v4.227a1.25,1.25,0,0,0,2.5,0V13.5a.25.25,0,0,1,.25-.25h4.227a1.25,1.25,0,0,0,0-2.5H13.5a.25.25,0,0,1-.25-.25V6.272a1.25,1.25,0,1,0-2.5,0V10.5a.25.25,0,0,1-.25.25H6.273a1.25,1.25,0,0,0,0,2.5Z']],
  SubtractCircleBold: ['subtract-circle-bold', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M12,23.5A11.5,11.5,0,1,0,.5,12,11.513,11.513,0,0,0,12,23.5Zm-6.5-12a1,1,0,0,1,1-1h11a1,1,0,0,1,1,1v1a1,1,0,0,1-1,1H6.5a1,1,0,0,1-1-1Z']],
  AddSquare: ['add-square', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M23.5,2A1.5,1.5,0,0,0,22,.5H2A1.5,1.5,0,0,0,.5,2V22A1.5,1.5,0,0,0,2,23.5H22A1.5,1.5,0,0,0,23.5,22ZM6,13a1,1,0,0,1,0-2h4.75a.25.25,0,0,0,.25-.25V6a1,1,0,0,1,2,0v4.75a.25.25,0,0,0,.25.25H18a1,1,0,0,1,0,2H13.25a.25.25,0,0,0-.25.25V18a1,1,0,0,1-2,0V13.25a.25.25,0,0,0-.25-.25Z']],
  RemoveBoldAlternate: ['remove-bold-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M18.186,12.176a.25.25,0,0,1,0-.353l3.889-3.888a2.255,2.255,0,0,0,0-3.183l-2.829-2.83a2.255,2.255,0,0,0-3.182,0l-3.889,3.89a.251.251,0,0,1-.354,0L7.933,1.923a2.253,2.253,0,0,0-3.182,0L1.923,4.752a2.252,2.252,0,0,0,0,3.182l3.889,3.889a.249.249,0,0,1,0,.353l-3.889,3.89a2.252,2.252,0,0,0,0,3.182L4.75,22.075a2.309,2.309,0,0,0,3.183,0l3.889-3.889a.25.25,0,0,1,.354,0l3.888,3.889a2.254,2.254,0,0,0,3.183,0l2.828-2.828a2.252,2.252,0,0,0,0-3.182Zm1.591,5.834-1.768,1.768a.5.5,0,0,1-.707,0l-4.419-4.419a1.251,1.251,0,0,0-1.768,0L6.7,19.778a.5.5,0,0,1-.707,0L4.221,18.01a.5.5,0,0,1,0-.707l4.419-4.42a1.249,1.249,0,0,0,0-1.767L4.221,6.7a.5.5,0,0,1,0-.707L5.989,4.221a.5.5,0,0,1,.707,0l4.419,4.42a1.254,1.254,0,0,0,1.768,0L17.3,4.221a.5.5,0,0,1,.707,0L19.777,5.99a.5.5,0,0,1,0,.707l-4.419,4.419a1.249,1.249,0,0,0,0,1.767l4.419,4.42A.5.5,0,0,1,19.777,18.01Z']],
  SubtractSquare: ['subtract-square', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M22,.5H2A1.5,1.5,0,0,0,.5,2V22A1.5,1.5,0,0,0,2,23.5H22A1.5,1.5,0,0,0,23.5,22V2A1.5,1.5,0,0,0,22,.5ZM19,12a1,1,0,0,1-1,1H6a1,1,0,0,1,0-2H18A1,1,0,0,1,19,12Z']],
  AddCircleBold: ['add-circle-bold', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M.5,12A11.5,11.5,0,1,0,12,.5,11.513,11.513,0,0,0,.5,12Zm5-.5a1,1,0,0,1,1-1h3.75a.25.25,0,0,0,.25-.25V6.5a1,1,0,0,1,1-1h1a1,1,0,0,1,1,1v3.75a.25.25,0,0,0,.25.25H17.5a1,1,0,0,1,1,1v1a1,1,0,0,1-1,1H13.75a.25.25,0,0,0-.25.25V17.5a1,1,0,0,1-1,1h-1a1,1,0,0,1-1-1V13.75a.25.25,0,0,0-.25-.25H6.5a1,1,0,0,1-1-1Z']],
  RemoveCircleAlternate: ['remove-circle-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M.249,12A11.751,11.751,0,1,0,12,.249,11.765,11.765,0,0,0,.249,12Zm21,0A9.251,9.251,0,1,1,12,2.749,9.262,9.262,0,0,1,21.251,12Z', 'M8.833,7.066A1.25,1.25,0,1,0,7.065,8.834l2.99,2.989a.25.25,0,0,1,0,.354l-2.99,2.99a1.25,1.25,0,1,0,1.768,1.767l2.989-2.989a.249.249,0,0,1,.354,0l2.99,2.989a1.249,1.249,0,1,0,1.767-1.767l-2.989-2.99a.25.25,0,0,1,0-.354l2.989-2.989a1.25,1.25,0,1,0-1.767-1.768l-2.99,2.99a.251.251,0,0,1-.354,0Z']],
  Remove: ['remove', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M.439,21.44a1.5,1.5,0,0,0,2.122,2.121L11.823,14.3a.25.25,0,0,1,.354,0l9.262,9.263a1.5,1.5,0,1,0,2.122-2.121L14.3,12.177a.25.25,0,0,1,0-.354l9.263-9.262A1.5,1.5,0,0,0,21.439.44L12.177,9.7a.25.25,0,0,1-.354,0L2.561.44A1.5,1.5,0,0,0,.439,2.561L9.7,11.823a.25.25,0,0,1,0,.354Z']],
  AddTab: ['add-tab', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M16,18.468a3.382,3.382,0,0,0,2.067-.832l4.775-4.584a1.455,1.455,0,0,0,0-2.107L18.062,6.364A3.385,3.385,0,0,0,16,5.532H2.212a1.5,1.5,0,0,0-1.5,1.5v9.936a1.5,1.5,0,0,0,1.5,1.5Zm-4.283-7.5a1,1,0,0,1,0,2H9.462a.25.25,0,0,0-.25.25v2.25a1,1,0,0,1-2,0v-2.25a.25.25,0,0,0-.25-.25H4.712a1,1,0,1,1,0-2h2.25a.25.25,0,0,0,.25-.25V8.468a1,1,0,0,1,2,0v2.25a.25.25,0,0,0,.25.25Z']],
  AddCircle1: ['add-circle-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M8.75,20.5c.146,0,.291,0,.435-.014a.249.249,0,0,0,.133-.45,9.97,9.97,0,0,1,0-16.071.25.25,0,0,0-.133-.451C9.041,3.505,8.9,3.5,8.75,3.5a8.5,8.5,0,0,0,0,17Z', 'M15.25,3.5a8.5,8.5,0,1,0,8.5,8.5A8.5,8.5,0,0,0,15.25,3.5Zm5,8.5a1,1,0,0,1-1,1H16.5a.25.25,0,0,0-.25.25V16a1,1,0,0,1-2,0V13.25A.25.25,0,0,0,14,13H11.25a1,1,0,0,1,0-2H14a.25.25,0,0,0,.25-.25V8a1,1,0,0,1,2,0v2.75a.25.25,0,0,0,.25.25h2.75A1,1,0,0,1,20.25,12Z']],
  SubtractBoldAlternate: ['subtract-bold-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M21.545,7.886H2.454a2.207,2.207,0,0,0-2.2,2.2v3.818a2.206,2.206,0,0,0,2.205,2.2H21.545a2.206,2.206,0,0,0,2.2-2.2V10.091A2.206,2.206,0,0,0,21.545,7.886Zm-.3,5.477a.25.25,0,0,1-.25.25H3a.25.25,0,0,1-.25-.25V10.636a.25.25,0,0,1,.25-.25H21a.25.25,0,0,1,.25.25Z']]
};
exports["default"] = _default;